import styled from "styled-components";

export const Container = styled.div`
  .MuiTypography-body1 {
    font-family: Poppins, sans-serif;
  }
`;
